import { LOCAL_STORAGE_KEYS } from "./localStorage";

// Marketing-attribution click IDs, mapped to the channel they identify. Order
// matters: the first param present wins, so Google's IDs take precedence over
// a stray msclkid. gbraid/wbraid are Google's iOS web<->app privacy click IDs.
const CLICK_ID_PARAMS: { param: string; source: string }[] = [
  { param: "gclid", source: "google_ads" },
  { param: "gbraid", source: "google_ads" },
  { param: "wbraid", source: "google_ads" },
  { param: "msclkid", source: "bing_ads" },
];

export interface Attribution {
  source?: string;
  clickId?: string;
}

// captureAttribution reads the current URL's query string and, if it carries an
// ad-platform click ID, persists it (last paid click wins). Call once at app
// load — the click ID is only on the landing URL, and the user may browse
// before ordering, so we stash it until checkout rather than reading it off the
// order form's URL (which no longer has it).
export const captureAttribution = (search: string): void => {
  const params = new URLSearchParams(search);
  for (const { param, source } of CLICK_ID_PARAMS) {
    const clickId = params.get(param);
    if (clickId) {
      try {
        window.localStorage.setItem(
          LOCAL_STORAGE_KEYS.ATTRIBUTION,
          JSON.stringify({ source, clickId })
        );
      } catch {
        // localStorage can throw (Safari private mode, quota). Attribution is
        // best-effort — never block the page over it.
      }
      return;
    }
  }
};

// getStoredAttribution returns the attribution captured on landing, or an empty
// object if none / unreadable.
export const getStoredAttribution = (): Attribution => {
  try {
    const raw = window.localStorage.getItem(LOCAL_STORAGE_KEYS.ATTRIBUTION);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw);
    return { source: parsed.source, clickId: parsed.clickId };
  } catch {
    return {};
  }
};
